<!-- <div class="translator logged-in mt-4">
    <form>
        <mat-form-field>
            <mat-label for="language">Select Language</mat-label>
            <mat-select name="language" [(ngModel)]="language" (ngModelChange)="changeLanguage()">
                <mat-option *ngFor="let lang of languages" [value]="lang.code" class="notranslate">{{lang.name}}
                </mat-option>
            </mat-select>

        </mat-form-field>
    </form>
</div> -->


<div class="dropdown google-translate" [hidden]="route.snapshot.queryParams.language">
    <div class="dropdown-toggle" [class.btn]="!plain" [class.btn-primary]="!plain" [class.btn-primary-mobile-resp]="!plain"
        [class.gt-plain]="plain"
        [ngClass]="{'slick-disabled':router.url.includes('/preview')}"
        [attr.style]="plain ? null :
  (settingsData?.bg_primary_color ? 'background-color: ' + settingsData.bg_primary_color + ' !important; ' : '') +
  (settingsData?.font_primary_color ? 'color: ' + settingsData.font_primary_color + '; ' : '') +
  (settingsData?.font_family ? 'font-family: ' + settingsData.font_family + '; ' : '') +
  'line-height: 1; border-radius: 8px;'
"
         type="button" (click)="clearSearch()"
        id="dropdownMenuButton" (click)="!router.url.includes('\/preview')  && pageFrom !== 'eventForm'? $event.preventDefault() : $event.stopPropagation();"  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

        <span class="d-inline-block w-150p notranslate">
            <span *ngIf="languageName.length <= 8" class="active-color">{{ languageName }}</span>
            <span *ngIf="languageName.length > 8" class="active-color" matTooltipPosition="above"
                matTooltip="{{languageName}}">
                {{ languageName | slice: 0:8 }}
                {{languageName.length > 8 ? "..." : ""}}
            </span></span>
    </div>
    <div class="dropdown-menu drpdwn-menu" aria-labelledby="dropdownMenuButton" [ngStyle]="{'--scroll-color': settingsData?.font_tertiary_color || '#888' ,'background-color':settingsData?.bg_tertiary_color,
    '--hover-bg': settingsData?.bg_secondary_color,
    '--hover-color': settingsData?.font_secondary_color}">
        <!-- <input type="text" placeholder="Search.." class="search-input"  [(ngModel)]="searchLang">
        <i class="fa fa-search drpdwn-search text-white " [ngClass]="{'user-search':userInfo?.id}" aria-hidden="true"></i> -->
        <!-- <span *ngFor="let lang of languages| filter: searchLang:'name';let i=index"  class="notranslate">
            <a class="dropdown-item fs-13" *ngIf="lang.lang" [ngClass]="{'pt-45':i == 0}"
                (click)="changeLanguage(lang)">{{lang.lang}}</a></span> -->
        <span *ngFor="let lang of languages| filter: searchLang:'name'" class="notranslate">
            <a class="dropdown-item fs-13 lang-link" [style.color]="settingsData?.font_tertiary_color" *ngIf="lang.lang" (click)="changeLanguage(lang)">{{lang.lang}}</a></span>
    </div>
</div>
<!-- <span class="dropdown" *ngIf="stageData?.length > 2">
    <div mat-flat-button class=" btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="text-truncate d-inline-block pt-2 w-150p">{{(stage?.stage)? stage?.stage:'Select
            stage'}}</span>
    </div>
    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <span *ngFor="let stage of stageData">
            <a class="dropdown-item fs-13" *ngIf="stage.stage"
                (click)="setStage(stage)">{{stage.stage}}</a></span>
    </div>
</span>  -->